import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Successschology() {
  return (
    <section className="success-schology p-100">
      <div className="img-right-purple">
        <StaticImage
          src="../../../images/case-studies/schology/ellipse-purple.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={593}
          height={913}
        />
      </div>

      <div className="img-right-green">
        <StaticImage
          src="../../../images/case-studies/schology/light-green-ellipse.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={557}
          height={913}
        />
      </div>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="mb-4 mb-md-0">
            <h2 style={{ color: "#111322" }}>
              Defining <span className="purple-box">Success</span>
            </h2>
            <h3 style={{ color: "#111322" }}>
              Key Goals Achieved Through a Unified Education Platform
            </h3>
            <StaticImage
              src="../../../images/case-studies/schology/success-img.webp"
              alt="TekRevol"
              layout="constrained"
              className="mt-4 mt-md-5"
              placeholder="blurred"
              formats={["webp"]}
              width={732}
              height={563}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <div className="success-box">
              <div className="num">01</div>
              <h5>Improve the Manageability of Educational Resources</h5>
              <p>
                The goal was to streamline access to academic content, classroom
                materials, and communication.
              </p>
            </div>
            <div className="success-box">
              <div className="num">02</div>
              <h5>Enhance Parent Collaboration</h5>
              <p>
                Strengthening the connection between schools and parents by
                providing real-time access to student performance and school
                activities.
              </p>
            </div>
            <div className="success-box">
              <div className="num">03</div>
              <h5>Unify Stakeholders Under One Platform</h5>
              <p>
                Creating a centralized system that could serve multiple schools
                while allowing seamless communication and data sharing between
                all stakeholders—students, teachers, and parents.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successschology;
